module.exports = __webpack_public_path__ + "img/layers.9722f7b6.svg";